"use strict";

import get from "lodash/get";
import isNil from "lodash/isNil";

import { getDefaultState } from "./auth-state";

export const mutations = {
  clearMfaErrors(state) {
    state.errorReference = null;
    state.errorMessage = null;
    state.invalidMfaCode = false;
  },
  clearSocialSignInStatus(state) {
    state.selectedSocialConnection = null;
    state.isRedirectingSocialSignIn = false;
    state.isOngoingSocialSignIn = false;
  },
  resetMfaState(state) {
    Object.assign(state, getDefaultState());
  },
  setAuthToken(state, token) {
    state.authToken = token;
  },
  setMfaToken(state, response) {
    const mfaToken = get(response, "data.metadata.mfa_token", null);
    if (mfaToken) {
      state.mfaToken = mfaToken;
    }
  },
  setMfaUserDetails(state, response) {
    state.userDetails.email = get(response, "data.metadata.email", null);
    state.userDetails.phone = get(response, "data.metadata.phone", null);
  },
  setMfaNonceIfAvailable(state, response) {
    const nonce = get(response, "data.metadata.nonce", null);
    if (nonce) {
      state.nonce = nonce;
    }
  },
  setMfaPreferredChannel(state, response) {
    const preferredChannel = get(
      response,
      "data.metadata.preferred_channel",
      null
    );
    if (preferredChannel) {
      state.preferredChannel = preferredChannel;
    } else {
      console.warn("MFA preferred channel not available. Defaulting to SMS");
      state.preferredChannel = "sms";
    }
  },
  setAuthErrorMessage(state, message) {
    state.errorMessage = message;
  },
  setMfaExpiration(state, response) {
    const expiration = get(response, "data.metadata.expiration", null);
    if (expiration) {
      state.mfaExpiresAt = expiration;
    }
  },
  setMfaRemainingAttempts(state, response) {
    const remainingAttempts = get(response, "data.metadata.remaining_attempts");
    if (!isNil(remainingAttempts)) {
      state.remainingAttempts = remainingAttempts;
    }
  },
  setMfaNextResend(state, response) {
    const nextResend = get(response, "data.metadata.next_resend", null);
    if (nextResend) {
      state.mfaNextResend = nextResend;
    }
  },
  setMfaTemporaryBlockedTime(state, response) {
    const expiryTime = get(response, "data.metadata.expiry_time", null);
    if (expiryTime) {
      state.temporaryBlockedTime = expiryTime;
    }
  },
  setMfaTemporaryBlocked(state, flag) {
    state.isTemporaryBlocked = flag;
  },
  setMfaBlocked(state, flag) {
    state.isBlocked = flag;
  },
  setPendingAccountProfile(state, response) {
    const accountEmail = get(response, "data.metadata.email");
    if (accountEmail) {
      state.pendingAccountEmail = accountEmail;
    }
    const profile = get(response, "data.metadata.profile");
    if (profile) {
      state.pendingAccountProfile = profile;
    }
  },
  setRegistrationToken(state, response) {
    const registrationToken = get(response, "data.metadata.registration_token");
    if (registrationToken) {
      state.registrationToken = registrationToken;
    }
  },
  setPendingAccountLinkingProfile(state, response) {
    state.pendingAccountLinkingProfile = {
      email: get(response, "data.metadata.email"),
      firstName: get(response, "data.metadata.first_name"),
      lastName: get(response, "data.metadata.last_name"),
      identityProvider: get(response, "data.metadata.identity_provider"),
    };
  },
  setAccountLinkingToken(state, response) {
    const accountLinkingToken = get(response, "data.metadata.linking_token");
    if (accountLinkingToken) {
      state.accountLinkingToken = accountLinkingToken;
    }
  },
  setAccountLinkingInvalidPassword(state, flag) {
    state.accountLinkingInvalidPassword = flag;
  },
  setSomethingWentWrongMessage(state) {
    state.errorMessage = "Something went wrong. Try again.";
  },
  setErrorReference(state, error) {
    if (error.requestId) {
      state.errorReference = error.requestId;
    }
  },
  setSocialSignInConnection(state, connection) {
    state.selectedSocialConnection = connection;
  },
  setIsRedirectingSocialSignIn(state, flag) {
    state.isRedirectingSocialSignIn = flag;
  },
  setIsOngoingSocialSignIn(state, flag) {
    state.isOngoingSocialSignIn = flag;
  },
  setVerificationProfile(state, response) {
    state.verificationProfile = {
      id: get(response, "data.metadata.user_id"),
      email: get(response, "data.metadata.email"),
      firstName: get(response, "data.metadata.first_name"),
      lastName: get(response, "data.metadata.last_name"),
      partnerId: get(response, "data.metadata.partner_id"),
    };
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  updatePendingAccountProfile(state, profile) {
    state.pendingAccountProfile = profile;
  },
};
